var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"mt-3 pt-0",attrs:{"dense":"","filled":"","solo":"","flat":"","id":_vm.id,"label":_vm.label,"loading":_vm.loading,"disabled":_vm.disabled,"hide-details":_vm.hideDetails,"outlined":"","placeholder":_vm.placeholder},model:{value:(_vm.textinput),callback:function ($$v) {_vm.textinput=$$v},expression:"textinput"}})
}
var staticRenderFns = []

export { render, staticRenderFns }